// extracted by mini-css-extract-plugin
export default {"frame":"Frame_frame__VVOQW","main":"Frame_main__BTeSy"};